import { API_URL } from '@/constants/config';
import { encodeQuery } from '~/modules/common/utils/routingUtils';
import { getAuthHeader } from '~/modules/common/utils/cookieUtils';

const base = API_URL + '/v3.5';

export const discoverService = (http, cookies) => ({
  /**
   * Get Trending Articles
   *
   * @param {number} page
   * @param {number} limit
   * @param {boolean} categories
   * @param {boolean} author
   */
  async getTrending({ page, limit, categories, author }) {
    const queryParams = encodeQuery({ page, limit, categories, author });
    const { data, pagination } = await http.$get(`${base}/browse/trending${queryParams}`);
    return { data, pagination };
  },
  async getDiscover({ page, limit, categoryIds, categories, breadcrumb, hashtags, author, reactions, comments, favoriteCheck = true }) {
    const queryParams = encodeQuery({
      page,
      limit,
      categoryIds,
      categories,
      breadcrumb,
      hashtags,
      author,
      reactions,
      comments,
      favoriteCheck,
    });
    const { data, pagination } = await http.$get(`${base}/browse/discover${queryParams}`, { headers: getAuthHeader(cookies) });
    return { data, pagination };
  },
});
